import type { WorkspaceMember } from '@/features/iam/members/WorkspaceMember'
import env from '@/infra/env'
import { PostHogTrackingService } from '@/features/tracking/PostHogTrackingService'
import { NoOpTrackingService } from '@/features/tracking/NoOpTrackingService'

export interface TrackingService {
  identify(member: WorkspaceMember): void

  reset(): void
}

export function createTrackingService() {
  return env.POSTHOG_KEY
    ? PostHogTrackingService.create()
    : NoOpTrackingService.create()
}
